import React, { useContext } from 'react'

export type TTransContext = {
	t: (key: string) => string
}

const TransContext = React.createContext<TTransContext>({
	t: () => ''
})

const useTrans = () => useContext(TransContext)

export { TransContext, useTrans }
